import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useNextStepsStyles = makeStyles({
    shippingSection: {
        display: 'flex',
        flexDirection: 'column',
        rowGap: tokens.spacingVerticalL
    },
    nextStepList: {
        display: 'grid',
        ...shorthands.gap(tokens.spacingVerticalL)
    },
    link: {
        color: tokens.colorBrandForegroundLink
    },
    questionsSection: {
        width: 'fit-content'
    },
    questionButtons: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'right',
        columnGap: tokens.spacingHorizontalM
    },
    successBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: tokens.colorPaletteGreenBackground2,
        columnGap: tokens.spacingVerticalM,
        ...shorthands.borderRadius('16px'),
        ...shorthands.border('0')
    }
});
